import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const enTranslation = require('./en/translation.json')

i18next.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation
    }
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});